import { ProductRender, renderKindFor } from "./ProductRender";

// A modest thumbnail beside an item's title, on the CIS order page's item and a Tharstern-era order's alike (Brad,
// 9 Oct): the item's own picture where we have one, else the product family's illustration where we can tell which
// it is, else nothing. We hold no product photography and the artwork's rendered first page is not served yet, so
// today it is the illustration for the products we draw (leaflets, cards, letterheads, NCR, signage) and nothing
// for the rest, never a generic placeholder.

export function ItemThumbnail({
  name,
  family,
  imageUrl,
}: {
  name: string;
  /** Product family or the spec line: more words for choosing the illustration. */
  family?: string | null;
  imageUrl?: string | null;
}) {
  const kind = renderKindFor({ name, product_family: family ?? "" });
  if (!imageUrl && kind === "sheet") return null;
  return (
    <div
      className="relative aspect-[4/3] w-20 shrink-0 overflow-hidden rounded-md border bg-muted/40 sm:w-24"
      data-testid="item-thumbnail"
    >
      {imageUrl ? (
        <img
          src={imageUrl}
          alt={`Artwork for ${name}`}
          className="size-full object-cover"
        />
      ) : (
        <ProductRender kind={kind} title={`${name} (illustration)`} />
      )}
    </div>
  );
}
